<template>
	<div class="card">
		<div class="card-image">
			<figure class="image is-4by3">
				<img
					:src="require(`@/assets/images/member-card-banners/${img}`)"
					alt="Placeholder image"
				/>
			</figure>
		</div>
		<div class="card-content">
			<div class="content">
				<slot name="content" />
			</div>
		</div>
		<footer class="card-footer">
			<slot name="footer" :selected="selected" />
		</footer>
	</div>
</template>

<script>
export default {
	name: 'MemberTypeCard',

	props: {
		img: {
			type: String,
			required: true,
			default: '1280x960.png',
		},
		selected: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style>
/* TODO: Use Bulma Vars */
.card-footer-item {
	color: #fff;
	background-color: #003c75;
}

.ksam-card-footer-item:hover {
	color: #fff !important;
	background-color: #cc1649;
}

.ksam-card-footer-item.selected {
	color: #fff !important;
	background-color: #cc1649;
}

.card {
	display: flex;
	flex-direction: column;
	height: 100%;
}

.card-footer {
	margin-top: auto;
}
</style>
